import { render, staticRenderFns } from "./KothonService.vue?vue&type=template&id=a4f8545e&scoped=true"
import script from "./KothonService.vue?vue&type=script&lang=js"
export * from "./KothonService.vue?vue&type=script&lang=js"
import style0 from "./KothonService.vue?vue&type=style&index=0&id=a4f8545e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f8545e",
  null
  
)

export default component.exports